import { render, staticRenderFns } from "./error-500.vue?vue&type=template&id=99450012&"
import script from "./error-500.vue?vue&type=script&lang=js&"
export * from "./error-500.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports